<template>
	<div class="register_msg_yz register_box">
		<h4 class="color_5babf4 login_title">注册成功！</h4>
		<p class="tip_sub_text">
			<small>请牢记您的账户和密码,忘记密码可用手机找回密码！</small>
		</p>
		<div class="account_password_box color_f clearfix">
			<h5 class="text-center">
				登录账户：<span>{{ mob }}</span>
			</h5>
			<h5 class="text-center pwdshow">
				登录密码：<span>{{ yhmm }}</span>
			</h5>
		</div>
		<p class="text-center">
			<a href="javascript:void(0);"></a>
			<a href="javascript:void(0);" @click="loginOption" class="btn btn_issue">登录选择</a>
		</p>
		<!--<div class="entrance_box text-center">
			<p>
				<span class="btn btn_issue" @click="getparentdata()" id="developerRegister">开发者(个人)</span>
			</p>
			<p>
				<span class="btn btn_issue" @click="getcompanydata()" id="companyDeveloperRegister">开发者(企业)</span>
			</p>
			<p>
				<span class="btn btn_issue" @click="createUserRole('101002')" id="teacherRegister">老师</span>
			</p>
			<p>
				<span class="btn btn_issue" @click="createUserRole('101004')" id="studentRegister">学生</span>
			</p>
			<p>
				<span class="btn btn_issue" @click="createUserRole('101003')" id="parentRegister">家长</span>
			</p>
		</div>-->

	</div>
</template>

<script>
	import { MessageBox } from 'element-ui'

	export default {
		name: 'register_msg_yz',
		data() {
			return {
				mob: this.$route.params.mobile,
				yhmm: this.$route.params.password,
				isLogin: this.$route.params.isLogin
			}
		},
		mounted: function() {
			this.$nextTick(function() {
				/*if(localStorage.getItem("token") != null) {
					$(".pwdshow").hide();
				}*/
				if(this.isLogin==1){
					$(".pwdshow").hide();
					this.queryUser();
				}
			})
		},
		methods: {
			loginOption() {
				this.$router.push({
						name: 'register_lx',
						params: {
							mobile: this.mob,
							password:this.yhmm
						}
					});
			},
			queryUser() {
				var temp = this;
				this.$http.post('/zklccloud/queryUser',{
					emulateJSON: true
				}).then(function(m) {
					this.mob = m.body.content.mob;
				})
			}

		}
	}
</script>

<style>
	.register_msg_yz {
		min-height: 500px;
	}
</style>


// WEBPACK FOOTER //
// register_success.vue?0c5371ac